import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { generateId } from "@pheaa/channels-component-library";

const FormSelect = props => {

	const {
		id = generateId(),
		label,
		onChange,
		options = [],
		value,
		...rest
	} = props;

	return (
		<FormControl fullWidth>
			<InputLabel id={`${id}-label`}>{label}</InputLabel>
			<Select
				id={id}
				label={label}
				labelId={`${id}-label`}
				onChange={onChange}
				value={value}
				{...rest}
			>
				{
					options.map(({ label, value, ...rest }, i) => (
						<MenuItem key={i} value={value} {...rest}>
							{label}
						</MenuItem>
					))
				}
			</Select>
		</FormControl>
	);
};

export default FormSelect;